var W, errorHandlerWithMsg, etdHelper, flatPluckCompact, getContentPromise, getRationaleContent, getRecContent, getStrengthOfRecommendation, keyBy, mediator, splitQuestionRecommendationId, visualizationUtils, _ref;

keyBy = require('lodash').keyBy;

_ref = require('lib/app_utils'), errorHandlerWithMsg = _ref.errorHandlerWithMsg, flatPluckCompact = _ref.flatPluckCompact;

etdHelper = require('lib/etd_helper');

splitQuestionRecommendationId = require('lib/questions_helper').splitQuestionRecommendationId;

getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;

W = require('when');

mediator = require('mediator');

getRecContent = function(recId, recommendationsData, etds) {
  var path, recommendation;
  if (recId.indexOf(etdHelper.MANUAL_REC_PREFIX) === 0) {
    return recommendationsData.getIn([recId, 'content'], '');
  } else if (!_.isEmpty(splitQuestionRecommendationId(recId)[1])) {
    if (recommendationsData.hasIn([recId, 'content'])) {
      return recommendationsData.getIn([recId, 'content'], '');
    } else {
      path = [splitQuestionRecommendationId(recId)[0], 'templateData', 'conclusions', 'sections', 'multipleRecommendations', 'recommendations'];
      recommendation = etds.getIn(path, Immutable.List()).find(function(rec) {
        return rec.get('_id') === splitQuestionRecommendationId(recId)[1];
      }, null, Immutable.Map());
      return recommendation.get('content', '');
    }
  } else {
    if (recommendationsData.hasIn([recId, 'content'])) {
      return recommendationsData.getIn([recId, 'content'], '');
    } else {
      path = [recId, 'templateData', 'conclusions', 'sections', 'recommendation', 'content'];
      return etds.getIn(path);
    }
  }
};

getRationaleContent = function(recId, recommendationsData) {
  if (recId.indexOf(etdHelper.MANUAL_REC_PREFIX) === 0) {
    return recommendationsData.getIn([recId, 'rationale'], '');
  } else if (!_.isEmpty(splitQuestionRecommendationId(recId)[1])) {
    return recommendationsData.getIn([recId, 'rationale'], '');
  } else {
    return recommendationsData.getIn([recId, 'rationale'], '');
  }
};

getStrengthOfRecommendation = function(recId, recommendationsData, etds) {
  var conclusionSections, path, recommendation;
  if (recId.indexOf(etdHelper.MANUAL_REC_PREFIX) === 0) {
    return recommendationsData.getIn([recId, 'strengthOfRecommendation'], '');
  } else if (!_.isEmpty(splitQuestionRecommendationId(recId)[1])) {
    if (!_.isEmpty(recommendationsData.getIn([recId, 'strengthOfRecommendation']))) {
      return recommendationsData.getIn([recId, 'strengthOfRecommendation'], '');
    } else {
      path = [splitQuestionRecommendationId(recId)[0], 'templateData', 'conclusions', 'sections', 'multipleRecommendations', 'recommendations'];
      recommendation = etds.getIn(path, Immutable.List()).find(function(rec) {
        return rec.get('_id') === splitQuestionRecommendationId(recId)[1];
      }, null, Immutable.Map());
      return recommendation.get('selectedOption', '');
    }
  } else {
    if (recommendationsData.has(recId)) {
      return recommendationsData.getIn([recId, 'strengthOfRecommendation'], '');
    } else {
      conclusionSections = etds.getIn([recId, 'templateData', 'conclusions', 'sections'], Immutable.List());
      return conclusionSections.get(etdHelper.getCurrentTORSectionId(conclusionSections)).get('selectedOption');
    }
  }
};

visualizationUtils = {
  VISUALIZATION_TEMPLATES: [
    {
      id: 'acp_visualization_template',
      chapters: [
        {
          title: 'general_information',
          editable: false,
          deletable: false,
          chapterType: 'acp_visual_guideline_general_information_form',
          sections: [
            {
              title: "",
              sectionType: 'acp_visual_guideline_general_information_form',
              content: '',
              data: {}
            }
          ]
        }, {
          title: 'recommendations',
          editable: false,
          deletable: false,
          chapterType: 'acp_visual_guideline_recommendations',
          sections: [
            {
              title: "populations",
              sectionType: 'acp_recommendations_populations',
              content: '',
              data: {}
            }
          ]
        }, {
          title: 'clinical_considerations',
          sections: [
            {
              title: "clinical_considerations",
              sectionType: 'visual_guideline_text_section'
            }, {
              title: "citations_for_full_guideline",
              sectionType: 'visual_guideline_text_section'
            }, {
              title: "citations_for_evidence_review",
              sectionType: 'visual_guideline_text_section'
            }
          ]
        }
      ]
    }
  ],
  getRecContent: getRecContent,
  getRationaleContent: getRationaleContent,
  getStrengthOfRecommendation: getStrengthOfRecommendation,
  getVisualizationData: function(tableData, populationsSection, etds) {
    var analysisGroups, outcomesIds, recommendationsData, recommendationsOrder, recsPromiseArr, _ref1;
    recommendationsData = populationsSection.getIn(['additionalData', 'recommendationsData'], Immutable.Map());
    recommendationsOrder = populationsSection.getIn(['additionalData', 'populations'], Immutable.List()).map(function(pop) {
      return pop.get('recommendations', Immutable.List());
    }).valueSeq().flatten().toJS();
    recsPromiseArr = recommendationsOrder.map((function(_this) {
      return function(recId) {
        var contentPromise, rationalePromise;
        contentPromise = getContentPromise("content_" + recId, getRecContent(recId, recommendationsData, etds));
        rationalePromise = getContentPromise("rationale_" + recId, getRationaleContent(recId, recommendationsData));
        return W.all([contentPromise, rationalePromise]).then(function(_arg) {
          var content, rationale;
          content = _arg[0], rationale = _arg[1];
          return {
            id: recId,
            title: '',
            content: content || '',
            rationale: rationale || '',
            strengthOfRecommendation: getStrengthOfRecommendation(recId, recommendationsData, etds)
          };
        });
      };
    })(this));
    _ref1 = tableData.get('populations', Immutable.Map()).reduce(function(acc, population) {
      population.get('interventionsData', Immutable.Map()).map(function(intervention) {
        return intervention.get('recommendationData', Immutable.Map()).map(function(recData) {
          return recData.get('analysis', Immutable.List()).map(function(analysis) {
            acc.outcomesIds = acc.outcomesIds.concat(analysis.get('outcomesOrder').toJS());
            return acc.analysisGroups = acc.analysisGroups.concat(analysis.get('_id'));
          });
        });
      });
      return acc;
    }, {
      outcomesIds: [],
      analysisGroups: []
    }), analysisGroups = _ref1.analysisGroups, outcomesIds = _ref1.outcomesIds;
    return W.all(recsPromiseArr).then(function(recs) {
      return keyBy(recs, 'id');
    }).then(function(recommendations) {
      return mediator.services.storePersistenceAdapter.fetch(mediator.project.id, _.uniq(outcomesIds)).then(function(outcomes) {
        return {
          recommendations: recommendations,
          outcomes: keyBy(flatPluckCompact(outcomes.rows, 'doc'), '_id'),
          analysisGroups: _.uniq(analysisGroups)
        };
      });
    })["catch"](function(err) {
      return errorHandlerWithMsg(err, $.t('vi:errors.prepare_data_error'));
    });
  }
};

module.exports = visualizationUtils;
